<template>
  <client-only>
    <el-dialog
      :model-value="visibility"
      :destroy-on-close="true"
      :show-close="showCloseButton"
      :close-on-click-modal="closeOnClickModal"
      :width="width"
      class="modal"
      :modal-class="modalClass"
      :close-icon="CloseIcon"
      :fullscreen="isFullScreen"
      :style="[
        isBottom && {
          position: 'fixed',
          bottom: '16px',
          left: '50%',
          transform: 'translateX(-50%)'
        },
        !isFullScreen && { 'border-radius': '12px', 'max-width': 'calc(500px - 32px)' },
        width && { width: width + ' !important' }
      ]"
      align-center
      center
      @close="$emit('click-close')"
    >
      <template
        v-if="title"
        #header
      >
        <div
          class="flex-align-center"
          :class="titleAlign === 'left' ? 'flex flex-space-between' : 'flex flex-justify-center'"
        >
          <h4
            class="modal-title"
            :style="titleAlign === 'left' ? 'text-align: left;' : 'text-align: center'"
          >
            {{ title }}
          </h4>
          <span
            v-if="headerSideText"
            class="header-side-text"
            @click="() => emits('click-header-side-text')"
          >
            {{ headerSideText }}
          </span>
        </div>
      </template>
      <div
        class="content"
        :style="`height: ${contentHeight}`"
        :class="[isFullScreen ? '' : 'px-16']"
      >
        <slot />
      </div>
      <template #footer>
        <div
          v-if="!hideButton"
          class="dialog-footer p-16 flex gap-8 mt-8"
          :class="buttonAlign === 'row' ? 'row-buttons' : 'flex-column'"
        >
          <CtaButton
            w-full
            :size="buttonSize"
            :text="mainButtonText"
            :disabled="mainButtonDisabled"
            @click-button="() => emits('click-main-button')"
          />
          <CtaButton
            v-if="subButton"
            w-full
            :size="buttonSize"
            :text="subButtonText"
            :disabled="subButtonDisabled"
            :type="isBottom ? 'quatenary' : 'tertiary'"
            @click-button="() => emits('click-sub-button')"
          />
        </div>
      </template>
    </el-dialog>
  </client-only>
</template>

<script setup lang="ts">
import CloseIcon from '~/components/atom/CloseIcon.vue'

const props = withDefaults(
  defineProps<{
    visibility?: boolean
    title?: string
    headerSideText?: string
    hideButton?: boolean
    subButton?: boolean
    mainButtonText?: string
    subButtonText?: string
    mainButtonDisabled?: boolean
    subButtonDisabled?: boolean
    width?: string
    contentHeight?: string
    titleAlign?: 'left' | 'center'
    buttonAlign?: 'column' | 'row'
    closeOnClickModal?: boolean
    buttonSize?: 'xs' | 'md' | 'base' | 'lg' | 'xl'
    showCloseButton?: boolean
    destroyOnClose?: boolean
    isBottom?: boolean // 바텀에 고정된 모달
    isFullScreen?: boolean
    // el-dialog 의 modal-class — 오버레이(.el-overlay)에 붙는다.
    // 특정 모달만 겨냥해 전역 스타일을 덮어써야 할 때 사용.
    modalClass?: string
  }>(),
  {
    visibility: false,
    title: '',
    headerSideText: '',
    hideButton: false,
    subButton: false,
    mainButtonText: '확인',
    subButtonText: '취소',
    mainButtonDisabled: false,
    subButtonDisabled: false,
    width: 'calc(100% - 32px)',
    contentHeight: 'auto',
    titleAlign: 'center',
    buttonAlign: 'column',
    closeOnClickModal: true,
    buttonSize: 'base',
    showCloseButton: false,
    destroyOnClose: false,
    isBottom: false,
    isFullScreen: false,
    modalClass: ''
  }
)

const emits = defineEmits([
  'click-close',
  'click-main-button',
  'click-sub-button',
  'click-header-side-text'
])
</script>

<style lang="scss" scoped>
.modal {
  color: $gray-700;
  .modal-title {
    @include body3-semibold;
    color: $gray-700;
  }
  .header-side-text {
    color: $brand-point;
    cursor: pointer;
    @include body7-medium;
  }
  .content {
    @include body4-regular;
    color: $gray-500;
    overflow: auto;
  }
  .row-buttons {
    flex-direction: row-reverse;
    :nth-child(1) {
      flex: 4;
    }
    :nth-child(2) {
      flex: 1;
    }
  }
  .dialog-footer {
    border-radius: 12px;
  }
}
</style>
